import Qs from "qs";
import type { IParseOptions } from "qs";

/**
 * Default `arrayLimit` for {@link parseQueryString}. `qs` uses `20` unless overridden; callers may pass a lower
 * `arrayLimit` in options if needed.
 */
const DEFAULT_PARSE_QUERY_STRING_ARRAY_LIMIT = 1_000_000;

/**
 * Baseline options for parsing URL query strings. Merged before caller `options`, so any `qs.parse` flag can be
 * overridden (including `arrayLimit`).
 */
const DEFAULT_URL_QUERY_PARSE_OPTIONS: Pick<IParseOptions, "arrayLimit"> = {
    arrayLimit: DEFAULT_PARSE_QUERY_STRING_ARRAY_LIMIT,
};

type ParseQueryStringOptions = IParseOptions & { decoder?: never | undefined; allowSparse?: boolean | undefined };
/**
 * Wrapper around `qs.parse` with EdgeTier defaults. Accepts the same options as `qs.parse`; **`arrayLimit` defaults to
 * {@link DEFAULT_PARSE_QUERY_STRING_ARRAY_LIMIT}** unless you pass another value in `options`. This is needed as new versions of
 * Qs "fixed" how the arrayLimit works with overflow values. Which has caused breaking changes in our codebase and how we use this function.
 * @param search - The URL search string to parse.
 * @param options - Optional options to pass to `qs.parse`.
 * @returns The parsed query string.
 */
export const parseQueryString = (search: string, options?: ParseQueryStringOptions) => {
    return Qs.parse(search, { ...DEFAULT_URL_QUERY_PARSE_OPTIONS, ...options });
};
